import { DashboardWidget, LayoutConfig } from "@sanity/dashboard";
import AlgoliaExporters from "./AlgoliaExporters";

export function algoliaExportersWidget(
  config: { layout?: LayoutConfig } = {}
): DashboardWidget {
  return {
    name: "algolia-exporters",
    component: () => <AlgoliaExporters />,
    layout: config.layout ?? { width: "medium" }
  };
}
